import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule, routingComponents } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { BannerComponent } from './banner/banner.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material/material.module';
import { SocialMediaComponent } from './social-media/social-media.component';
import { FooterComponent } from './footer/footer.component';
import { FullViewComponent } from './gallery/full-view/full-view.component';
import { HomeComponent } from './home/home.component';
import { HeaderNewComponent } from './header-new/header-new.component';
import { CovidServicesNewComponent } from './covid-update/covid-services-new/covid-services-new.component';
import { CovidSafetyMeasuresComponent } from './covid-update/covid-safety-measures/covid-safety-measures.component';
import { CovidPickupDeliveryComponent } from './covid-update/covid-pickup-delivery/covid-pickup-delivery.component';
import { CovidOrderFromHomeComponent } from './covid-update/covid-order-from-home/covid-order-from-home.component';
import { CovidBannerNotificationComponent } from './covid-update/covid-banner-notification/covid-banner-notification.component';
// import { CovidAcceptedPaymentsBannerComponent } from './covid-update/covid-accepted-payments-banner/covid-accepted-payments-banner.component';
import { ContactNumberComponent } from './covid-update/contact-number/contact-number.component';
import { LandscapeViewHiddenComponent } from './landscape-view-hidden/landscape-view-hidden.component';
import { NewAboutUsComponent } from './new-about-us/new-about-us.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { WhyUsComponent } from './why-us/why-us.component';
import { NewContactUsComponent } from './new-contact-us/new-contact-us.component';
import { AboutFooterComponent } from './new-about-us/about-footer/about-footer.component';
import { NewServiceComponent } from './new-service/new-service.component';
import { ServiceHeaderComponent } from './new-service/service-header/service-header.component';
import { ServicePortfolioComponent } from './new-service/service-portfolio/service-portfolio.component';
import { ServiceFooterComponent } from './new-service/service-footer/service-footer.component';
import { WhyusHeaderComponent } from './why-us/whyus-header/whyus-header.component';
import { WhyusSafetymeasuresComponent } from './why-us/whyus-safetymeasures/whyus-safetymeasures.component';
import { WhyusFooterComponent } from './why-us/whyus-footer/whyus-footer.component';
import { ContactHeaderComponent } from './new-contact-us/contact-header/contact-header.component';
import { ContactBannerComponent } from './new-contact-us/contact-banner/contact-banner.component';
import { ContactFooterComponent } from './new-contact-us/contact-footer/contact-footer.component';
import { MatPortfolioComponent } from './new-service/service-portfolio/mat-portfolio/mat-portfolio.component';



// import { MatProgressSpinnerModule } from '@angular/material';
// import { WhyUsComponent } from './why-us/why-us.component'
// import { NgxSpinnerModule } from 'ngx-spinner';
// import { CarouselModule } from '@coreui/angular';



@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    BannerComponent,
    SocialMediaComponent,
    FooterComponent,
    FullViewComponent,
    HomeComponent,
    routingComponents,
    HeaderNewComponent,
    CovidServicesNewComponent,
    CovidPickupDeliveryComponent,
    CovidSafetyMeasuresComponent,
    CovidOrderFromHomeComponent,
    CovidBannerNotificationComponent,
    // CovidAcceptedPaymentsBannerComponent,
    ContactNumberComponent,
    LandscapeViewHiddenComponent,
    NewAboutUsComponent,
    ContactUsComponent,
    WhyUsComponent,
    NewContactUsComponent,
    AboutFooterComponent,
    NewServiceComponent,
    ServiceHeaderComponent,
    ServicePortfolioComponent,
    ServiceFooterComponent,
    WhyusHeaderComponent,
    WhyusSafetymeasuresComponent,
    WhyusFooterComponent,
    ContactHeaderComponent,
    ContactBannerComponent,
    ContactFooterComponent,
    MatPortfolioComponent,



  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,




  ],
  providers: [],
  bootstrap: [AppComponent],
  entryComponents: [FullViewComponent, MatPortfolioComponent]
})
export class AppModule { }
